export const pathFromApi = link => link.replace('/api', '/view-asset')

export const apiFromPath = path => `${process.env.REACT_APP_API_HOST}/api/${path}`



// WEBPACK FOOTER //
// ./src/ui/gov-messages/display-asset/helpers.js